import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Clock = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg viewBox="0 0 26.799 26.799" width={size} height={size} fill={iconColor}>
      <title>{iconTitle}</title>
      <g data-name="Layer 2">
        <g data-name="Layer 6">
          <path
            className="cls-1"
            d="M13.4 26.799a13.4 13.4 0 1 1 13.399-13.4 13.414 13.414 0 0 1-13.4 13.4zm0-25.299a11.9 11.9 0 1 0 11.899 11.9 11.913 11.913 0 0 0-11.9-11.9z"
          />
          <path
            className="cls-1"
            d="M22.979 11.15a.748.748 0 0 0-.903-.559l-7.882 1.852a1.24 1.24 0 0 0-.795-.304 1.26 1.26 0 0 0-1.26 1.26 1.194 1.194 0 0 0 .04.203l-4.79 5.094a.75.75 0 1 0 1.093 1.028l4.786-5.09a1.182 1.182 0 0 0 .131.026 1.26 1.26 0 0 0 1.157-.761l7.864-1.848a.75.75 0 0 0 .559-.901z"
          />
        </g>
      </g>
    </svg>
  );
};

Clock.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Clock.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Clock);
